import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux/es/exports";
import Loading from "../../components/UI/Loading";
import { fetchRelatedBlogs } from "../../features/RelatedBlogs/RelatedBlogsSlice";
import RelatedPost from "./RelatedPost";

export default function RelatedPosts() {
  const dispatch = useDispatch();
  const { blog } = useSelector((state) => state.blog);
  const { relatedBlogs, isLoading, isError, error } = useSelector(
    (state) => state.relatedBlogs
  );

  const { id, tags } = blog || {};

  useEffect(() => {
    dispatch(fetchRelatedBlogs({ tags, id }));
  }, [dispatch, tags, id]);

  // decide what to render
  let content = null;
  if (isLoading) content = <Loading />;

  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isLoading && !isError && !relatedBlogs?.id) {
    content = <div className="col-span-12">No Related Blog found!</div>;
  }

  if (!isLoading && !isError && relatedBlogs?.length > 0) {
    content = relatedBlogs.map((relatedBlog) => (
      <RelatedPost key={relatedBlog?.id} relatedBlog={relatedBlog} />
    ));
  }
  return (
    <>
      <aside>
        <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
          Related Posts
        </h4>
        <div className="space-y-4 related-post-container">{content}</div>
      </aside>
    </>
  );
}
